export default "/images/f7163dd605189825855aa446c2da5dc1.avif";